import domReady from '@wordpress/dom-ready';

/**
 * Update CSS variable with header height
 */
function updateHeaderHeight() {
	const header = document.querySelector(
		'header.site-header.wp-block-template-part'
	);

	if (!header) return;

	const headerNav = header.querySelector(':scope > .wp-block-group');

	const height = headerNav.offsetHeight;
	document.documentElement.style.setProperty(
		'--header-height',
		`${height}px`
	);
}

/**
 * Handle scroll behavior - add/remove pinned/unpinned classes
 */
function initHeaderScroll() {
	const header = document.querySelector(
		'header.site-header.wp-block-template-part'
	);

	if (!header) return;

	const headerNav = header.querySelector(':scope > .wp-block-group');

	let lastScrollTop = 0;
	let ticking = false;

	function updateHeaderClasses() {
		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;
		const scrollDelta = scrollTop - lastScrollTop;

		// At top
		if (scrollTop <= 100) {
			headerNav.classList.add('is-top', 'is-pinned');
			headerNav.classList.remove('not-top', 'is-unpinned');
		}
		// Scrolling down - hide header
		else if (scrollDelta > 5) {
			headerNav.classList.add('not-top', 'is-unpinned');
			headerNav.classList.remove('is-top', 'is-pinned');
		}
		// Scrolling up - show header
		else if (scrollDelta < -5) {
			headerNav.classList.add('not-top', 'is-pinned');
			headerNav.classList.remove('is-top', 'is-unpinned');
		}

		lastScrollTop = scrollTop;
		ticking = false;
	}

	function requestTick() {
		if (!ticking) {
			requestAnimationFrame(updateHeaderClasses);
			ticking = true;
		}
	}

	headerNav.classList.add('is-pinned', 'is-top');

	window.addEventListener('scroll', requestTick, { passive: true });

	updateHeaderClasses();
}

/**
 * Initialize header
 */
function initHeader() {
	const header = document.querySelector(
		'header.site-header.wp-block-template-part'
	);

	if (!header) return;

	updateHeaderHeight();

	const resizeObserver = new ResizeObserver(updateHeaderHeight);
	resizeObserver.observe(header);

	initHeaderScroll();
}

/**
 * Make entire card clickable
 */
function makeCardClickable(card) {
	// Find the main link (in title or button)
	const titleLink = card.querySelector('.wp-block-post-title a');
	const buttonLink = card.querySelector('.wp-block-button a');
	const mainLink = titleLink || buttonLink;

	if (!mainLink) return;

	let mouseDownData, mouseUpData;

	// Helper to capture mouse/touch position and scroll
	function captureInteractionData() {
		return {
			timestamp: Date.now(),
			scrollY: window.scrollY,
			scrollX: window.scrollX,
		};
	}

	// Add cursor pointer to indicate clickability
	card.style.cursor = 'pointer';

	// Capture start of interaction
	const handleStart = () => {
		mouseDownData = captureInteractionData();
	};

	card.addEventListener('mousedown', handleStart, { passive: true });
	card.addEventListener('touchstart', handleStart, { passive: true });

	// Handle click
	card.addEventListener(
		'click',
		(event) => {
			mouseUpData = captureInteractionData();

			// Ignore if clicked on a button or link directly
			const clickedButton = event.target.closest('button');
			const clickedLink = event.target.closest('a');
			if (clickedButton || clickedLink) return;

			// Ignore if it was a long press (> 200ms) - user might be selecting text
			if (mouseUpData.timestamp - mouseDownData.timestamp > 200) return;

			// Ignore if user scrolled (drag gesture)
			const verticalScroll = Math.abs(
				mouseUpData.scrollY - mouseDownData.scrollY
			);
			const horizontalScroll = Math.abs(
				mouseUpData.scrollX - mouseDownData.scrollX
			);
			if (verticalScroll > 5 || horizontalScroll > 5) return;

			// Trigger click on main link
			const syntheticClick = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window,
			});
			mainLink.dispatchEvent(syntheticClick);
		},
		{ passive: true }
	);
}

/**
 * Initialize clickable cards
 */
function initClickableCards() {
	const cards = document.querySelectorAll('.is-entire-card-clickable');
	cards.forEach(makeCardClickable);
}
const heroSlides = [
	{
		src: 'http://st-pauls.test/wp-content/uploads/2026/02/header-bg.jpg',
		srcset: 'http://st-pauls.test/wp-content/uploads/2026/02/header-bg.jpg 1920w, hhttp://st-pauls.test/wp-content/uploads/2026/02/header-bg-300x169.jpg 300w, hhttp://st-pauls.test/wp-content/uploads/2026/02/header-bg-1024x576.jpg 1024w, hhttp://st-pauls.test/wp-content/uploads/2026/02/header-bg-768x432.jpg 768w, hhttp://st-pauls.test/wp-content/uploads/2026/02/header-bg-1536x864.jpg 1536w',
		sizes: '(max-width: 1920px) 100vw, 1920px',
	},
	{
		src: 'https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-1.jpg',
		srcset: 'https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-1.jpg 1920w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-1-300x169.jpg 300w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-1-1024x576.jpg 1024w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-1-768x432.jpg 768w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-1-1536x864.jpg 1536w',
		sizes: '(max-width: 1920px) 100vw, 1920px',
	},
	{
		src: 'https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-2.jpg',
		srcset: 'https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-2.jpg 1920w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-2-300x169.jpg 300w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-2-1024x576.jpg 1024w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-2-768x432.jpg 768w, https://st-pauls.test/wp-content/uploads/2026/02/textorial-park-2-1536x864.jpg 1536w',
		sizes: '(max-width: 1920px) 100vw, 1920px',
	},
];

class CoverSlideshow {
	constructor(img, slides) {
		this.img = img;
		this.slides = slides;
		this.current = 0;
		this.duration = 5000;

		if (this.slides.length > 1) this.init();
	}

	init() {
		this.interval = setInterval(() => this.next(), this.duration);

		document.addEventListener('visibilitychange', () => {
			document.hidden ? this.stop() : this.start();
		});
	}

	next() {
		this.current = (this.current + 1) % this.slides.length;
		const slide = this.slides[this.current];

		this.img.style.opacity = '0';

		setTimeout(() => {
			this.img.src = slide.src;
			this.img.srcset = slide.srcset;
			this.img.sizes = slide.sizes;
			this.img.style.opacity = '1';
		}, 700);
	}

	stop() {
		clearInterval(this.interval);
	}
	start() {
		this.interval = setInterval(() => this.next(), this.duration);
	}
}

const img = document.querySelector(
	'.slideshow .wp-block-cover__image-background'
);
if (img) new CoverSlideshow(img, heroSlides);
domReady(() => {
	initHeader();
	initClickableCards();
});
